export default __webpack_public_path__ + "static/media/Shelter-Animals-Count_Sample_Services-Import.a91fab62.csv";